const jsLibrary = `const yaml = require('yaml');
const fs = require('fs');

class SMApplyConnect {

\tconstructor(configFile) {
\t\tconst file = fs.readFileSync(configFile, 'utf8');
\t\tconst config = yaml.parse(file)
\t\tthis.configFile = configFile
\t\tthis.accessToken = config.accessToken
\t\tthis.refreshToken = config.refreshToken
\t\tthis.clientSecret = config.clientSecret
\t\tthis.clientId = config.clientId
\t\tthis.server = config.server
\t}

\tsaveConfig() {
\t\tconst data = {
\t\t\t"server": this.server,
\t\t\t"clientId": this.clientId,
\t\t\t"clientSecret": this.clientSecret,
\t\t\t"refreshToken": this.refreshToken,
\t\t\t"accessToken": this.accessToken,
\t\t};

\t\tfs.writeFileSync(this.configFile, yaml.stringify(data));
\t}
\t
\tasync refreshTheToken() {
\t\tconst url = \`\${this.server}/api/o/token/\`;
\t\tconst data = {
\t\t\t"grant_type": 'refresh_token',
\t\t\t"client_id": this.clientId,
\t\t\t"client_secret": this.clientSecret,
\t\t\t"refresh_token": this.refreshToken,
\t\t}

\t\tconst response = await fetch(url, {
\t\t\tmethod: 'POST',
\t\t\theaders: {'Content-Type': 'application/x-www-form-urlencoded'},
\t\t\tbody: new URLSearchParams(data)
\t\t});

\t\tif (response.status === 200) {
\t\t\tconst newToken = await response.json();
\t\t\tthis.accessToken = newToken['access_token']
\t\t\tthis.refreshToken = newToken['refresh_token']
\t\t\tthis.saveConfig()
\t\t}
\t}

\tasync call({method, endpoint, params, data, headers}) {
\t\tconst url = new URL(\`\${this.server}/api/\${endpoint}/\`);
\t\theaders.Authorization = \`Bearer \${this.accessToken}\`;

\t\tlet response;
\t\tif (method === 'POST' || method === 'PATCH') {
\t\t\tfor (const key of params)
\t\t\t\turl.searchParams.set(key, params[key]);
\t\t\tresponse = await fetch(url.toString(), {
\t\t\t\tmethod: method,
\t\t\t\theaders: headers,
\t\t\t\tbody: JSON.stringify(data)
\t\t\t})

\t\t} else {
\t\t\tfor (const key of Object.keys(params))
\t\t\t\turl.searchParams.set(key, params[key]);
\t\t\tconst fullUrl = url.toString();
\t\t\ttry {
\t\t\t\tresponse = await fetch(fullUrl, {
\t\t\t\t\tmethod: method,
\t\t\t\t\theaders: headers,
\t\t\t\t});
\t\t\t} catch(err) {
\t\t\t\tconsole.log(err);
\t\t\t}

\t\t}
\t\treturn response;
\t}

\tasync makeCall({method, endpoint, params, data, headers}) {
\t\tconst props = {
\t\t\tmethod: method,
\t\t\tendpoint: endpoint,
\t\t\tparams: params || {},
\t\t\tdata: data,
\t\t\theaders: headers || {}
\t\t};

\t\tlet response = await this.call(props);

\t\tif (response.status === 403) {
\t\t\tawait this.refreshTheToken();
\t\t\tresponse = await this.call(props);
\t\t}

\t\treturn response;
\t}

}

module.exports = SMApplyConnect;`;

const jsExampleProgram = `const SMApplyConnect = require("./connect");

(async () => {
\tconst connect = new SMApplyConnect('connect.yaml');
\tconst response = await connect.makeCall({method: 'GET', endpoint: 'applications'});
\tconst responseJSON = await response.json();
\tconsole.log(responseJSON);
})()
.then(() => process.exit(0))
.catch(err => {
  console.log(err.stack);
  process.exit(0);
});
`;


module.exports = {
	jsLibrary: jsLibrary,
	jsExampleProgram: jsExampleProgram,
};
